module.exports = __webpack_public_path__ + "static/media/success.7013003a.svg";